




































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { store } from "../store/mainStore";
import Visao from "../components/Visao.vue";
import Missao from "../components/Missao.vue";
import Valores from "../components/Valores.vue";
import Estrutura from "../components/Estrutura.vue";
import Marca from "../components/Marca.vue";

@Component({
  components: {
    Visao,
    Missao,
    Valores,
    Estrutura,
    Marca,
  },
})
export default class Empresa extends Vue {
  heightCabecalho: any = null;

  mounted() {
    this.getAlturaCabecalho();
  }
  scrollToMissao() {
    let elemento = this.$refs.missao as any;
    let y = this.heightCabecalho as any;
    elemento.scrollIntoView() + window.scrollBy(0, -56);
  }
  scrollToVisao() {
    let elemento = this.$refs.missao as any;
    elemento.scrollIntoView();
  }
  scrollToValores() {
    let elemento = this.$refs.visao as any;
    elemento.scrollIntoView();
  }
  scrollToOrganizacional() {
    let elemento = this.$refs.valores as any;
    elemento.scrollIntoView();
  }
  scrollToMarca() {
    let elemento = this.$refs.organizacional as any;
    elemento.scrollIntoView();
  }
  scrollToTrabConosco() {
    let elemento = this.$refs.marca as any;
    elemento.scrollIntoView();
  }
  // OBTEM DA STORE O VALOR DA ALTURA DO CABECALHO
  getAlturaCabecalho() {
    this.heightCabecalho = this.$store.state.alturaCabecalho;
    // console.log(this.heightCabecalho);
  }
}
